import { render, staticRenderFns } from "./team_members.vue?vue&type=template&id=388d4de0&scoped=true&"
import script from "./team_members.vue?vue&type=script&lang=js&"
export * from "./team_members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d4de0",
  null
  
)

export default component.exports